import useAuth from 'src/hooks/useAuth';
import { useUserProfile } from 'src/contexts/UserProfileContext';
import { resolveIsResellerOrg } from 'src/mindtime/utils/subscriptionPermissions';

/** Reseller org from profile (preferred) or auth session while profile loads. */
export const useIsResellerOrg = (): boolean => {
  const { user } = useAuth();
  const { userData } = useUserProfile();
  const organizationTypeName =
    userData?.organization?.organizationTypeName ?? user?.organization?.organizationTypeName;
  return resolveIsResellerOrg(organizationTypeName);
};

/** Org type name from profile or auth session. */
export const useOrganizationTypeName = (): string | undefined => {
  const { user } = useAuth();
  const { userData } = useUserProfile();
  return userData?.organization?.organizationTypeName ?? user?.organization?.organizationTypeName;
};
